module.exports = __webpack_public_path__ + "img/broad_bg.66772441.png";